import React from "react";
import { Alert, AlertProps } from "@mui/material";

// Inline sizing also overrides the website theme's viewport-based body2 media rule.
export default function AffiliateNotice(props: Pick<AlertProps, "children" | "severity" | "role">) {
  return <Alert {...props} style={{ fontSize: "0.625rem", lineHeight: 1.3 }} sx={{
    py: 0,
    px: 1,
    minWidth: 0,
    maxWidth: "100%",
    alignItems: "flex-start",
    overflowWrap: "anywhere",
    "& .MuiAlert-message": { fontSize: "inherit", lineHeight: "inherit", py: 0.75, minWidth: 0 },
    "& .MuiAlert-icon": { fontSize: "0.875rem", py: 0.625, mr: 0.75 },
    "& .MuiButton-root": { fontSize: "inherit", lineHeight: "inherit", minWidth: 0, py: 0.5 },
  }} />;
}
